import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const PersonalInfoIcon: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--personal-info-icon')}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    data-icon={icon}
  >
    <path
      d="M15.91 17.398c5.213 0 9.504 3.485 9.656 7.904l.004.241h-1.5c0-3.636-3.626-6.645-8.16-6.645-4.444 0-8.015 2.89-8.156 6.428l-.004.217h-1.5c0-4.532 4.353-8.145 9.66-8.145zM29.5 15v1.5h-7V15h7zM15.91 4.707c3.1 0 5.61 2.545 5.61 5.68s-2.51 5.68-5.61 5.68c-3.1 0-5.61-2.545-5.61-5.68s2.51-5.68 5.61-5.68zm0 1.5c-2.267 0-4.11 1.869-4.11 4.18s1.843 4.18 4.11 4.18c2.267 0 4.11-1.869 4.11-4.18s-1.843-4.18-4.11-4.18zM29.5 12v1.5h-6V12h6zm0-3v1.5h-5V9h5z"
      fill="#000"
      fillRule="nonzero"
    />
  </svg>
);

export default PersonalInfoIcon;
